/**
 * Client-side guardrails for business/profile image uploads (QA D6 + D14).
 *
 * - Type: only raster images we can safely render through an <img>. SVG is
 *   rejected here AND at the presign backend — it can carry <script> (stored XSS).
 * - Size: capped at 5 MB. NB: a presigned PUT to R2 can't enforce content-length
 *   server-side, so THIS is the real size gate; the backend still rejects bad
 *   content-types. Keep the two in sync.
 */
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024; // 5 MB

export const ALLOWED_IMAGE_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif',
] as const;

export type ImageValidationError = 'type' | 'size';

export function validateImageFile(file: File): { ok: boolean; error?: ImageValidationError } {
    if (!(ALLOWED_IMAGE_TYPES as readonly string[]).includes(file.type)) {
        return { ok: false, error: 'type' };
    }
    if (file.size > MAX_IMAGE_BYTES) {
        return { ok: false, error: 'size' };
    }
    return { ok: true };
}
